import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

import { AnalyticsService } from './shared/services/fb-analytics.service';
import { Location } from '@angular/common';

@Component({
  selector: 'root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  constructor(
    protected analyticsService: AnalyticsService
  ) { } 

  async ngOnInit(): Promise<void> {
    try {
      await this.analyticsService.setHtmlMeta();
    } catch(e) {
      console.error(e);
    } finally {
      if (this.analyticsService.cookieName('consent_dn')) {
        this.analyticsService.updateConsent('denied');
      } else {
        this.analyticsService.updateConsent('granted');
      }

      this.analyticsService.analytics();
    }
  }
}
